import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import HttpClientXml from "../utils/HttpClientXml";
import HomeService from "../Services/HomeService";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

function ManageWallOfFrame() {
  const [wallOfFame, setWallOfFame] = useState([]);
  const [loading, setLoading] = useState(false);
  const [itemID, setItemID] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState({
    image: "",
    name: "",
    designation: "",
  });

  const columns = [
    {
      name: "S.No.",
      selector: (row, index) => index + 1,
      sortable: true,
    },
    {
      name: "Image",
      cell: (row) => (
        <img
          src={row.image || "/placeholder-image.png"}
          alt="Person"
          width="60"
          height="60"
          style={{
            borderRadius: "8px",
            objectFit: "cover",
            border: "1px solid #dee2e6",
          }}
        />
      ),
      center: true,
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      cell: (row) => (
        <div className="d-flex align-items-center">
          <span style={{ minWidth: "50px" }}>
            {row.name || <span className="text-muted">No name</span>}
          </span>
        </div>
      ),
    },
    {
      name: "Designation",
      cell: (row) => (
        <div className="d-flex align-items-center">
          <span className="me-2" style={{ minWidth: "50px" }}>
            {row.designation || (
              <span className="text-muted">No designation</span>
            )}
          </span>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Created Date",
      selector: (row) =>
        new Date(
          row.createdAt || row.createdOn || row.updatedAt
        ).toLocaleDateString(),
      sortable: true,
      center: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <div>
          <button
            title="Edit"
            onClick={() => handleEdit(row)}
            className="btn btn-sm me-2"
            style={{
              background: "transparent",
              border: "none",
              color: "rgb(133, 218, 79)",
            }}
          >
            <i className="fa-solid fa-pen-to-square fs-5"></i>
          </button>
          <button
            title="Delete"
            onClick={() => handleDelete(row._id)}
            className="btn btn-sm"
            style={{
              background: "transparent",
              border: "none",
              color: "#dc3545",
            }}
          >
            <i className="fa-solid fa-trash-can fs-5"></i>
          </button>
        </div>
      ),
      center: true,
    },
  ];

  // Fetch all wall of fame items
  const fetchWallOfFame = async () => {
    setLoading(true);
    try {
      const res = await HomeService.getWallOfFame();
      console.log("Wall of Fame data:", res.data);
      setWallOfFame(res.data);
    } catch (error) {
      console.error("Error fetching wall of fame:", error);
      toast.error("Failed to load wall of fame!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWallOfFame();
  }, []);

  // Handle edit button click
  const handleEdit = (row) => {
    setIsEdit(true);
    setEditData({
      image: row.image || "",
      name: row.name || "",
      designation: row.designation || "",
    });
    setItemID(row._id);
  };

  // Handle delete button click with SweetAlert confirmation
  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete Wall of Fame Entry?",
      text: "Are you sure you want to delete this wall of fame entry?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        const res = await HomeService.deleteWallOfFame(id);
        if (res?.status) {
          Swal.fire(
            "Deleted!",
            "Wall of Fame entry has been deleted.",
            "success"
          );
          fetchWallOfFame();
        } else {
          toast.error(res?.message || "Failed to delete entry");
        }
      } catch (error) {
        Swal.fire("Error!", "Failed to delete wall of fame entry.", "error");
      }
    }
  };

  // Handle image upload
  const handleImageUpload = async (e) => {
    if (!e.target.files[0]) return;

    const data = new FormData();
    data.append("image", e.target.files[0]);
    try {
      const res = await HttpClientXml.fileUplode("image-upload", "POST", data);
      if (res?.image) {
        setEditData({ ...editData, image: res.image });
        toast.success("Image uploaded successfully!");
      }
    } catch (error) {
      toast.error("Failed to upload image.");
      console.error("Error uploading image:", error);
    }
  };

  // Handle form submission for update
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!editData.name.trim()) {
      toast.error("Please enter a name.");
      return;
    }

    if (!editData.designation.trim()) {
      toast.error("Please enter a designation.");
      return;
    }

    if (!editData.image) {
      toast.error("Please upload an image.");
      return;
    }

    try {
      // Prepare update data
      const data = {
        image: editData.image,
        name: editData.name.trim(),
        designation: editData.designation.trim(),
      };

      console.log("Updating wall of fame with data:", data);

      const res = await HomeService.updateWallOfFame(itemID, data);

      if (res?.status) {
        toast.success("Wall of Fame entry updated successfully!");
        setIsEdit(false);
        setEditData({ image: "", name: "", designation: "" });
        fetchWallOfFame();
      } else {
        toast.error(res?.message || "Failed to update wall of fame entry.");
      }
    } catch (error) {
      toast.error("Failed to update wall of fame entry.");
      console.error("Error updating wall of fame:", error);
    }
  };

  // Handle cancel edit
  const handleCancel = () => {
    setIsEdit(false);
    setEditData({ image: "", name: "", designation: "" });
  };

  return (
    <>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          {isEdit ? (
            <section className="chartBox_area">
              <div className="card">
                <div className="card-header">
                  <h4 className="mb-0">Edit Wall of Fame Entry</h4>
                </div>
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      {/* Image Upload Section */}
                      <div className="col-md-6 mt-3">
                        <label>
                          Image<span className="text-danger">*</span>
                        </label>
                        {editData.image && (
                          <div className="mt-2 mb-2">
                            <img
                              src={editData.image}
                              alt="Person Preview"
                              style={{
                                maxHeight: "150px",
                                maxWidth: "100%",
                                borderRadius: "8px",
                                border: "2px solid #dee2e6",
                                objectFit: "cover",
                              }}
                            />
                          </div>
                        )}
                        <input
                          type="file"
                          className="form-control"
                          onChange={handleImageUpload}
                          accept="image/*"
                        />
                        <small className="text-muted">
                          Upload person's image
                        </small>
                      </div>

                      {/* Name Input */}
                      <div className="col-md-6 mt-3">
                        <label htmlFor="name">
                          Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="name"
                          className="form-control"
                          value={editData?.name || ""}
                          onChange={(e) =>
                            setEditData((prev) => ({
                              ...prev,
                              name: e.target.value,
                            }))
                          }
                          placeholder="Enter person's name..."
                          required
                        />
                        <small className="text-muted">
                          Enter the name of the person
                        </small>
                      </div>

                      {/* Designation Input */}
                      <div className="col-md-12 mt-3">
                        <label htmlFor="designation">
                          Designation<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="designation"
                          className="form-control"
                          value={editData?.designation || ""}
                          onChange={(e) =>
                            setEditData((prev) => ({
                              ...prev,
                              designation: e.target.value,
                            }))
                          }
                          placeholder="Enter designation (e.g., CEO & Founder)..."
                          required
                        />
                        <small className="text-muted">
                          Enter the designation or title of the person
                        </small>
                      </div>
                    </div>

                    <div className="mt-4 pt-3 border-top">
                      <button
                        type="submit"
                        className="btn btn-primary me-3"
                        style={{
                          background: "rgb(133, 218, 79)",
                          border: "none",
                          padding: "10px 25px",
                          fontWeight: "500",
                        }}
                      >
                        <i className="fa-solid fa-floppy-disk me-2"></i>
                        Save Changes
                      </button>
                      <button
                        type="button"
                        onClick={handleCancel}
                        className="btn btn-secondary"
                        style={{
                          padding: "10px 25px",
                          fontWeight: "500",
                        }}
                      >
                        <i className="fa-solid fa-times me-2"></i>
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </section>
          ) : (
            <>
              <div className="mt-5">
                <div style={headLineStyle} className="page-headline">
                  Manage Wall of Fame
                </div>
                {loading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2">Loading wall of fame...</p>
                  </div>
                ) : wallOfFame.length > 0 ? (
                  <div className="card">
                    <div className="card-body">
                      <DataTable
                        columns={columns}
                        data={wallOfFame}
                        pagination
                        responsive
                        highlightOnHover
                        striped
                        paginationPerPage={10}
                        paginationRowsPerPageOptions={[10, 20, 30, 50]}
                        noDataComponent={
                          <div className="text-center py-4">
                            <i className="fa-solid fa-trophy fa-2x text-muted mb-3"></i>
                            <p>No wall of fame entries found</p>
                          </div>
                        }
                      />
                    </div>
                  </div>
                ) : (
                  <div className="card">
                    <div className="card-body text-center py-5">
                      <i className="fa-solid fa-trophy fa-3x text-muted mb-3"></i>
                      <h5>No Wall of Fame Entries Available</h5>
                      <p className="text-muted">
                        There are no wall of fame entries to display at the
                        moment.
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default ManageWallOfFrame;
